var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c("v-card-title", [
        _c("span", { staticClass: "headline" }, [
          _vm._v("Generate Config File"),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "v-card-text",
        [
          _c("strong", [_vm._v("Enter Service Account Credentials:")]),
          _vm._v(" "),
          _c(
            "v-form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", lg5: "", "ma-2": "" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          autofocus: false,
                          autocomplete: "off",
                          "hide-no-data": true,
                          items: _vm.allUsers,
                          rules: [_vm.rules.required],
                          "prepend-icon": "fas fa-user",
                          label: "Service Account",
                          "item-text": "login",
                          "item-value": "login",
                        },
                        model: {
                          value: _vm.email,
                          callback: function ($$v) {
                            _vm.email = $$v
                          },
                          expression: "email",
                        },
                      }),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: {
                          autocomplete: "off",
                          id: "password",
                          rules: [_vm.rules.required],
                          "prepend-icon": "fas fa-lock",
                          name: "password",
                          label: "Password",
                          type: "password",
                        },
                        model: {
                          value: _vm.password,
                          callback: function ($$v) {
                            _vm.password = $$v
                          },
                          expression: "password",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", lg5: "", "ma-2": "" } },
                    [
                      _c("h3", [_vm._v("Collection Options:")]),
                      _vm._v(" "),
                      _c(
                        "v-radio-group",
                        {
                          model: {
                            value: _vm.options,
                            callback: function ($$v) {
                              _vm.options = $$v
                            },
                            expression: "options",
                          },
                        },
                        [
                          _c("v-radio", {
                            attrs: {
                              label: "All (Endpoints and Infrastructure)",
                              value: "All",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-radio", {
                            attrs: {
                              label: "Endpoints Only",
                              value: "EPM-Only",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-radio", {
                            attrs: {
                              label: "Infrastructure Only",
                              value: "Systems-Only",
                            },
                          }),
                          _vm._v(" "),
                          _vm.options === "Specific"
                            ? _c("v-select", {
                                attrs: {
                                  label: "Select Drivers",
                                  items: _vm.drivers,
                                  "menu-props": { maxHeight: "400" },
                                  multiple: "",
                                },
                                model: {
                                  value: _vm.selectedDrivers,
                                  callback: function ($$v) {
                                    _vm.selectedDrivers = $$v
                                  },
                                  expression: "selectedDrivers",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { "ma-2": "" } },
                    [
                      _c("h3", [_vm._v("Proxy Details:")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "caption" }, [
                        _vm._v(
                          "\n            Is there a proxy server that the collector must use to reach infrastructure, endpoints and the WXP Collaboration Cloud?\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", "mr-4": "" } },
                            [
                              _c("v-select", {
                                attrs: { items: _vm.proxyTypes },
                                model: {
                                  value: _vm.selectedProxyType,
                                  callback: function ($$v) {
                                    _vm.selectedProxyType = $$v
                                  },
                                  expression: "selectedProxyType",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.selectedProxyType === "https"
                            ? [
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", "mr-4": "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "Proxy server",
                                        rules: [_vm.rules.required],
                                      },
                                      model: {
                                        value: _vm.proxyserver,
                                        callback: function ($$v) {
                                          _vm.proxyserver = $$v
                                        },
                                        expression: "proxyserver",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", "mr-4": "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: { label: "Proxy port" },
                                      model: {
                                        value: _vm.proxyport,
                                        callback: function ($$v) {
                                          _vm.proxyport = $$v
                                        },
                                        expression: "proxyport",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", "mr-2": "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "Proxy username",
                                        "prepend-icon": "fas fa-user",
                                      },
                                      model: {
                                        value: _vm.proxyusername,
                                        callback: function ($$v) {
                                          _vm.proxyusername = $$v
                                        },
                                        expression: "proxyusername",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        "prepend-icon": "fas fa-lock",
                                        label: "Proxy password",
                                        type: "password",
                                      },
                                      model: {
                                        value: _vm.proxypassword,
                                        callback: function ($$v) {
                                          _vm.proxypassword = $$v
                                        },
                                        expression: "proxypassword",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.selectedProxyType !== null
                        ? _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs8: "", "ma-1": "" } },
                                [
                                  _c("v-textarea", {
                                    attrs: {
                                      hint: "Use commas to separate multiple addresses",
                                      "persistent-hint": "",
                                      label: "Bypass list",
                                    },
                                    model: {
                                      value: _vm.proxybypasslist,
                                      callback: function ($$v) {
                                        _vm.proxybypasslist = $$v
                                      },
                                      expression: "proxybypasslist",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-actions",
        [
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: {
                color: "primary",
                outlined: "",
                rounded: "",
                disabled: !_vm.valid,
              },
              on: {
                click: function ($event) {
                  return _vm.getConfigFile()
                },
              },
            },
            [_vm._v("Get Config File")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }